/* eslint-disable global-require */
module.exports = ['artprice.web.pages.classifieds.decorative.details.m18'];
